var _path, _ellipse, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78163 9.45587C7.15426 9.45587 9.07742 7.53167 9.07742 5.15835C9.07742 2.78503 7.15426 0.860828 4.78163 0.860828C2.40899 0.860828 0.485828 2.78503 0.485828 5.15835C0.485828 7.53167 2.40899 9.45587 4.78163 9.45587Z",
    fill: "#242426",
    stroke: "#363636",
    strokeWidth: 0.661157
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.78091,
    cy: 5.15735,
    rx: 3.30435,
    ry: 3.30578,
    fill: "#4D4D59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76351 7.80171C7.56611 7.1986 8.08526 6.23837 8.08526 5.15683C8.08526 4.07515 7.56598 3.11482 6.7632 2.51172C5.9606 3.11483 5.44145 4.07506 5.44145 5.1566C5.44145 6.23828 5.96073 7.19861 6.76351 7.80171ZM2.79853 7.80187C3.60095 7.19874 4.11998 6.23862 4.11998 5.15721C4.11998 4.07558 3.60073 3.11528 2.79802 2.51218C1.99559 3.1153 1.47656 4.07543 1.47656 5.15683C1.47656 6.23846 1.99581 7.19877 2.79853 7.80187Z",
    fill: "#61616D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.79252,
    cy: 4.16752,
    r: 0.991735,
    fill: "#9C9CA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c19855e67dd0025b32610ca3c6e1f29c.svg";
export { ForwardRef as ReactComponent };